import services from "../services";
import * as types from "./mutation-type";

export const setOpenCalendar = ({ commit }, payload) => {
    commit(types.SET_OPEN_CALENDAR, payload);
};

export const ActionGetCalendar = async ({ _ }, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.getCalendar(payload);
        if (data.error === false) {
            resolve(data);
        }
        reject(data);
    });
};
